module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex"
  }, [(_vm.showEmpty === true) ? _c('div', {
    staticClass: "flex-content",
    staticStyle: {
      "text-align": "center",
      "margin-top": "100px",
      "opacity": "0.6"
    }
  }, [_c('span', [_vm._v("您的购物车是空的")]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/shop/index"
    }
  }, [_c('x-button', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("去购买")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.showEmpty === true) ? _c('foot-nav', {
    attrs: {
      "selectBar": "uc"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showEmpty === false) ? _c('div', {
    staticClass: "flex-content"
  }, [_vm._l((_vm.cartItemsList), function(p, k) {
    return _c('group', {
      key: k,
      attrs: {
        "title": p.title
      }
    }, _vm._l((p.list), function(i) {
      return _c('cell', {
        key: i.id,
        attrs: {
          "title": i.title,
          "value": 'x ' + i.amount,
          "is-link": ""
        },
        nativeOn: {
          "click": function($event) {
            _vm.goToCate(p.cateId)
          }
        }
      }, [_c('img', {
        staticStyle: {
          "display": "block",
          "margin-right": "5px"
        },
        attrs: {
          "slot": "icon",
          "width": _vm.iconWidth,
          "height": _vm.iconWidth,
          "src": _vm.tianYiWebUrl + i.img
        },
        slot: "icon"
      })])
    }))
  }), _vm._v(" "), _c('group', {
    attrs: {
      "title": "收货地址"
    }
  }, [(_vm.address.name !== undefined) ? _c('cell', {
    attrs: {
      "title": _vm.address.name + ' (' + _vm.address.tel + ')',
      "is-link": "",
      "inline-desc": _vm.address.provence + _vm.address.city + _vm.address.region + _vm.address.street
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleAddressList()
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": require("../../assets/dizhiicon.png"),
      "width": "30"
    },
    slot: "icon"
  })]) : _vm._e(), _vm._v(" "), (_vm.address.name === undefined) ? _c('cell', {
    attrs: {
      "title": "还未设置收货地址",
      "is-link": "",
      "inline-desc": "点击选择地址"
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleAddressList()
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": require("../../assets/dizhiicon.png"),
      "width": "30"
    },
    slot: "icon"
  })]) : _vm._e()], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "买家留言"
    }
  }, [_c('x-textarea', {
    attrs: {
      "max": 240,
      "placeholder": "请备注特殊您的特殊需求"
    },
    model: {
      value: (_vm.userRemark),
      callback: function($$v) {
        _vm.userRemark = $$v
      },
      expression: "userRemark"
    }
  }), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showQuickRemark = true
      }
    }
  }, [_vm._v("快捷留言")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('actionsheet', {
    attrs: {
      "menus": _vm.remarkPreList,
      "close-on-clicking-mask": true,
      "close-on-clicking-menu": true,
      "show-cancel": ""
    },
    on: {
      "on-click-menu": _vm.addToUserRemark
    },
    model: {
      value: (_vm.showQuickRemark),
      callback: function($$v) {
        _vm.showQuickRemark = $$v
      },
      expression: "showQuickRemark"
    }
  })], 1), _vm._v(" "), (_vm.addonProduct.show) ? _c('group', {
    attrs: {
      "title": "优惠加购"
    }
  }, [_c('checklist', {
    attrs: {
      "options": _vm.addonProduct.list
    },
    on: {
      "on-change": _vm.clickAddonProduct
    },
    model: {
      value: (_vm.selectedAdonProduct),
      callback: function($$v) {
        _vm.selectedAdonProduct = $$v
      },
      expression: "selectedAdonProduct"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.redPackage.length > 0) ? _c('group', {
    attrs: {
      "title": "优惠券"
    }
  }, [_c('checklist', {
    attrs: {
      "max": 1,
      "options": _vm.redPackage,
      "disabled": ""
    },
    on: {
      "on-change": _vm.changeDiscount
    },
    model: {
      value: (_vm.redPackType),
      callback: function($$v) {
        _vm.redPackType = $$v
      },
      expression: "redPackType"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('group', {
    attrs: {
      "title": "额外费用 - 新用户首单包邮"
    }
  }, [_c('cell', {
    attrs: {
      "title": "快递费",
      "value": _vm.shipFeeText
    }
  })], 1), _vm._v(" "), (_vm.paymentList.length > 0) ? _c('group', {
    attrs: {
      "title": "支付方式"
    }
  }, [_c('checklist', {
    attrs: {
      "max": 1,
      "options": _vm.paymentList
    },
    model: {
      value: (_vm.choosePaymentMethod),
      callback: function($$v) {
        _vm.choosePaymentMethod = $$v
      },
      expression: "choosePaymentMethod"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('popup', {
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "position": "right",
      "width": "100%"
    },
    model: {
      value: (_vm.showAddressList),
      callback: function($$v) {
        _vm.showAddressList = $$v
      },
      expression: "showAddressList"
    }
  }, [_c('x-header', {
    attrs: {
      "left-options": {
        preventGoBack: true
      }
    },
    on: {
      "on-click-back": function($event) {
        _vm.showAddressList = false
      }
    }
  }, [_vm._v("\n          地址列表 (" + _vm._s(this.addressList.length) + "/" + _vm._s(_vm.limitNumber) + ")\n        ")]), _vm._v(" "), _c('div', [(_vm.addressList.length) ? _c('group', {
    attrs: {
      "title": "向左滑动可编辑和删除地址"
    }
  }, [_c('swipeout', _vm._l((_vm.addressList), function(item, index) {
    return _c('swipeout-item', {
      key: item.id,
      attrs: {
        "transition-mode": "follow"
      },
      nativeOn: {
        "click": function($event) {
          _vm.chooseAddress(item)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "right-menu"
      },
      slot: "right-menu"
    }, [_c('swipeout-button', {
      attrs: {
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.onButtonClick('edit', item, index)
        }
      }
    }, [_vm._v("编辑\n                  ")]), _vm._v(" "), _c('swipeout-button', {
      attrs: {
        "type": "warn"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.onButtonClick('delete', item, index)
        }
      }
    }, [_vm._v(" 删除\n                  ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "address-item-box",
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('div', {
      staticClass: "address-l1"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/card.png"),
        "width": "20",
        "alt": ""
      }
    }), _c('span', {
      staticStyle: {
        "color": "#d4880f",
        "padding-right": "10px"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(_vm._s(item.tel) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "address-l2"
    }, [_vm._v("\n                    " + _vm._s(item.provence + ' ' + item.city + ' ' + item.region) + "\n                    "), _c('br'), _vm._v("\n                    " + _vm._s(item.street) + "\n                  ")])])])
  }))], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "15px 5px"
    }
  }, [_c('x-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.addressList.length >= _vm.limitNumber
    },
    nativeOn: {
      "click": function($event) {
        _vm.addAddress()
      }
    }
  }, [_vm._v("增加地址\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('popup', {
    attrs: {
      "position": "right",
      "width": "100%"
    },
    model: {
      value: (_vm.showEditAddress),
      callback: function($$v) {
        _vm.showEditAddress = $$v
      },
      expression: "showEditAddress"
    }
  }, [_c('x-header', {
    attrs: {
      "left-options": {
        preventGoBack: true
      }
    },
    on: {
      "on-click-back": function($event) {
        _vm.showEditAddress = false
      }
    }
  }, [_vm._v("地址编辑\n        ")]), _vm._v(" "), _c('group', [_c('x-input', {
    attrs: {
      "title": "收货人",
      "placeholder": "收货人（中文）",
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.formAddress['name']),
      callback: function($$v) {
        _vm.$set(_vm.formAddress, 'name', $$v)
      },
      expression: "formAddress['name']"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "手机号码",
      "max": 11,
      "is-type": "china-mobile",
      "placeholder": "11位手机号码",
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.formAddress['tel']),
      callback: function($$v) {
        _vm.$set(_vm.formAddress, 'tel', $$v)
      },
      expression: "formAddress['tel']"
    }
  }), _vm._v(" "), _c('x-address', {
    attrs: {
      "title": "所在区域",
      "list": _vm.addressData,
      "placeholder": "选择省市区",
      "popup-style": {
        zIndex: 502
      }
    },
    model: {
      value: (_vm.formAddress['pcr']),
      callback: function($$v) {
        _vm.$set(_vm.formAddress, 'pcr', $$v)
      },
      expression: "formAddress['pcr']"
    }
  }), _vm._v(" "), _c('x-textarea', {
    attrs: {
      "title": "详细地址",
      "placeholder": "楼道",
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.formAddress['street']),
      callback: function($$v) {
        _vm.$set(_vm.formAddress, 'street', $$v)
      },
      expression: "formAddress['street']"
    }
  }), _vm._v(" "), _c('x-switch', {
    attrs: {
      "title": "是否默认"
    },
    model: {
      value: (_vm.formAddress['is_default']),
      callback: function($$v) {
        _vm.$set(_vm.formAddress, 'is_default', $$v)
      },
      expression: "formAddress['is_default']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "40px",
      "padding": "5px"
    }
  }, [_c('x-button', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.postAddress()
      }
    }
  }, [_vm._v("提交\n          ")])], 1)], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.showEmpty === false) ? _c('div', {
    staticClass: "foot-button"
  }, [_c('flexbox', [_c('flexbox-item', {
    attrs: {
      "span": 7
    }
  }, [_c('div', {
    staticClass: "flex-demo"
  }, [_vm._v("现金：¥ " + _vm._s((_vm.shownTotalPrice - 0) + _vm.ship_fee + _vm.addonProductPrice) + " 元")])]), _vm._v(" "), _c('flexbox-item', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "flex-demo"
  }, [_c('x-button', {
    attrs: {
      "slot": "label",
      "type": "warn",
      "disabled": _vm.submitBtnDisabled
    },
    nativeOn: {
      "click": function($event) {
        _vm.doOrder($event)
      }
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.submitBtnText) + "\n          ")])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('actionsheet', {
    attrs: {
      "menus": _vm.menus,
      "show-cancel": ""
    },
    on: {
      "on-click-menu": _vm.handleActionSheet
    },
    model: {
      value: (_vm.showMenus),
      callback: function($$v) {
        _vm.showMenus = $$v
      },
      expression: "showMenus"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f24dbc4"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cart/Index.vue
// module id = 715
// module chunks = 0